import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/Api/brand.CombineEvent/getCombineEventList',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/Api/brand.CombineEvent/delCombineEvent',
    method: 'post',
    data
  })
}

export function close(data) {
  return request({
    url: '/Api/brand.CombineEvent/forceCloseEvent',
    method: 'post',
    data
  })
}

export function getProductList(data) {
  return request({
    url: '/Api/brand.CombineEvent/getEventProduct',
    method: 'post',
    data
  })
}


export function editCombineEvent(data) {
  return request({
    url: '/Api/brand.CombineEvent/editCombineEvent',
    method: 'post',
    data
  })
}

export function saveCombineEvent(data) {
  return request({
    url: '/Api/brand.CombineEvent/saveCombineEvent',
    method: 'post',
    data
  })
}

export function getOnStatusList(data) {
  return request({
    url: '/Api/brand.CombineEvent/getOnStatusList',
    method: 'post',
    data
  })
}

export function CombineEventData(data) {
  return request({
    url: '/Api/brand.CombineEvent/CombineEventData',
    method: 'post',
    data
  })
}

export function CombineEventChart(data) {
  return request({
    url: '/Api/brand.CombineEvent/CombineEventChart',
    method: 'post',
    data
  })
}
export function getRelationPlan(data) {
  return request({
    url: '/Api/brand.CombineEvent/getRelationPlan',
    method: 'post',
    data
  })
}
export function getPointList(data) {
  return request({
    url: '/Api/brand.CombineEvent/getPointList',
    method: 'post',
    data
  })
}